<template>

  <div class="col-12 py-5">
    <m-content-wrapper slicer="4" @contents="dataReady" :content-category="contentCategory"
                       :content-type="contentType">
      <template v-slot="{contents}">
        <div class="gallery gallery-cards css-selector row">
          <div class="content panel col-lg-6 col-md-6 col-sm-12 p-2">
            <div v-for="(content,index) in contents" class="slide" :data-order="index+1">
              <h3><span>{{ content.title }}</span></h3>
              <m-a class="button" :href="{name:'SinglePost',params:{slug:content.slug}}">
                <span class=" px-3 my-2" v-t="`content.card.more`"></span>
              </m-a>
            </div>
          </div>
          <div class="images panel col-lg-6 col-md-6 col-sm-12 ">

            <div v-for="(content,index) in contents" class="slide" :data-order="index+1">
              <m-a :href="{name:'SinglePost',params:{slug:content.slug}}">
                <m-img :src="content.thumbnail" :alt="content.title"/>
              </m-a>
            </div>

          </div>
        </div>
      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import mContentWrapper from "../../Wrappers/ContentWrapper";
import mA from '../../Tags/A'
import mImg from '../../Tags/Img'

export default {
  name: "s14",
  components: {mContentWrapper, mA, mImg},
  props: {
    contentCategory: {
      type: Object,
      default: null
    },
    contentType: {
      default: 'post'
    }
  },
  methods: {
    initSection() {
      var galleries = document.querySelectorAll(".gallery-cards"),
          activeIndex = 0,
          timeout;

      if (!document.documentElement.classList || 0 === galleries.length) return; // Bail early

      galleries.forEach(function (gallery) {
        var images = gallery.querySelector(".images"),
            content = gallery.querySelector(".content"),
            imageSlides = images.querySelectorAll(".slide"),
            contentSlides = content.querySelectorAll(".slide"),
            length = imageSlides ? imageSlides.length : null;

        setInterval(function () {
          window.requestAnimationFrame(
              animateSlides.bind(this, imageSlides, contentSlides, length)
          );
        }, 4000);
      });

      function animateSlides(imageSlides, contentSlides, length) {
        imageSlides.forEach(function (slide, index) {
          var order = slide.dataset.order;
          if (order == 1) {
            slide.classList.add("leave");
            slide.dataset.order = length;
            contentSlides[index].dataset.order = length;
            slide.addEventListener(
                "transitionend",
                handleTransitionEnd.bind(slide, length)
            );
          } else {
            slide.dataset.order = --slide.dataset.order;
            contentSlides[index].dataset.order = --contentSlides[index].dataset
                .order;
          }
        });
      }

      function handleTransitionEnd(length, e) {
        this.classList.remove("leave");
        this.removeEventListener("transitionend", handleTransitionEnd);
      }
    },
    dataReady() {
      setTimeout(() => {
        this.initSection()
      }, 100)
    }
  }
};
</script>
<style scoped>
img {
  max-width: 100%;
}


.button {
  display: inline-block;
  padding: 0.75em 1.25em;
  border: 1px solid #fff;
  border-radius: 4px;
  font-size: 1.25em;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  line-height: 1;
}

.gallery {
  height: 500px;

}

.gallery img {
  float: left;
}

.gallery,
.gallery .slide,
.gallery-image,
.gallery-image .content,
.gallery-image:before {
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  transition: all 0.3s ease-in-out;
}

.gallery-cards .slide {
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-out;
}

.gallery-cards .panel {

}

.gallery-cards .slide {
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 0;
  transform: translateY(-50%) translateX(-50%);
}

.gallery-cards .content {

  color: #fff;
  text-align: center;
}

.gallery-cards .content .slide {
  opacity: 0;
}

.gallery-cards .content .slide[data-order="1"] {
  opacity: 1;
}

.gallery-cards .content h2 {
  font-size: 3em;
}

.gallery-cards .images {
  overflow-y: hidden;

  -webkit-perspective: 1000;
  perspective: 1000;
}

.gallery-cards .images .slide[data-order="1"] {
  transform: translateY(-50%) translateX(-50%) translateZ(0) scale(1);
  z-index: 1004;
}

.gallery-cards .images .slide[data-order="2"] {
  transform: translateY(-60%) translateX(-40%) translateZ(-50px) scale(0.95);
  z-index: 1003;
  opacity: 0.85;
}

.gallery-cards .images .slide[data-order="3"] {
  transform: translateY(-70%) translateX(-30%) translateZ(-100px) scale(0.9);
  z-index: 1002;
  opacity: 0.7;
}

.gallery-cards .images .slide[data-order="4"] {
  transform: translateY(-80%) translateX(-20%) translateZ(-150px) scale(0.85);
  z-index: 1001;
  opacity: 0;
}

.gallery-cards .images .slide.leave {
  transform: translateY(0) translateX(-50%) translateZ(0);
  z-index: 1005;
}

.gallery-cards .images .slide:before {
  content: none;
}

.css-selector {
  background: linear-gradient(270deg, var(--primary), var(--secondary));
  background-size: 400% 400%;

  -webkit-animation: AnimationName 7s ease infinite;
  -moz-animation: AnimationName 7s ease infinite;
  -o-animation: AnimationName 7s ease infinite;
  animation: AnimationName 7s ease infinite;
}

@-webkit-keyframes AnimationName {
  0% {
    background-position: 0% 50%
  }
  50% {
    background-position: 100% 50%
  }
  100% {
    background-position: 0% 50%
  }
}

@-moz-keyframes AnimationName {
  0% {
    background-position: 0% 50%
  }
  50% {
    background-position: 100% 50%
  }
  100% {
    background-position: 0% 50%
  }
}

@-o-keyframes AnimationName {
  0% {
    background-position: 0% 50%
  }
  50% {
    background-position: 100% 50%
  }
  100% {
    background-position: 0% 50%
  }
}

@keyframes AnimationName {
  0% {
    background-position: 0% 50%
  }
  50% {
    background-position: 100% 50%
  }
  100% {
    background-position: 0% 50%
  }
}
</style>
